import api from "./index";

const login = (type, body) => {
    return api.post(`/login/${type}`, body);
}
const createAccount = (body) => {
    return api.post(`/user`, body);
}

const verifyEmailLink = (body) => {
    return api.post(`/verify-email-signup`, body);
}

const forgotPassword = (email) => {
    return api.get(`/forgot-password/${email}`);
}

const verifyEmailForgotPassword = (body) => {
    return api.post(`/verify-email-forgot-password`, body);
}

const resetPassword = (body) => {
    return api.put(`/reset-password`, body);
}

const me = () => {
    return api.get(`/me`);
}

const userList = () => {
    return api.get(`/users`);
}

const userDetails = (userId) => {
    return api.get(`/user-details/${userId}`);
}

const logoutDevice = () => {
    return api.get(`/logout-device`);
}

const fireWebhook = async (webhookUrl, accessToken, deviceId) => {
    if (!webhookUrl) return;
    try {
        const url = new URL(webhookUrl);
        url.searchParams.append('accessToken', accessToken);
        if (deviceId) url.searchParams.append('deviceId', deviceId);

        await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ accessToken, deviceId })
        });
    } catch (e) {
        console.error("Failed to fire webhook:", e);
    }
}

const createApp = (body) => {
    return api.post(`/apps/register`, body);
}

const myApps = (body) => {
    return api.get(`/apps/my-apps`, body);
}

const verifyApp = (appId) => {
    return api.get(`/apps/verify/${appId}`);
}

const updateApp = (appId, body) => {
    return api.put(`/apps/${appId}`, body);
}

const deleteApp = (appId) => {
    return api.delete(`/apps/${appId}`);
}

const storeSsoSession = (body) => {
    return api.post('/authorize/session', body);
}

const pollSsoSession = (requestId) => {
    return api.get(`/authorize/poll/${requestId}`);
}

const getActivity = (year) => {
    return api.get(`/activity?year=${year}`);
}

const getSyncStatus = () => {
    return api.get(`/activity/sync-status`);
}

export {
    me,
    login,
    createAccount,
    verifyEmailLink,
    forgotPassword,
    verifyEmailForgotPassword,
    resetPassword,
    logoutDevice,
    userList,
    userDetails,
    fireWebhook,
    createApp,
    myApps,
    verifyApp,
    updateApp,
    deleteApp,
    storeSsoSession,
    pollSsoSession,
    getActivity,
    getSyncStatus
}
